import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CatalogsVehicleInterface } from './catalog-vehicle.models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EndpointConstants } from 'src/app/core/services/endpoints-configurations/endpoint-constants';
import { ProjectSettingsService } from 'src/app/core/services/common/project-settings.service';

@Injectable({ providedIn: 'root' })
export class CatalogsVehicleStoreService {
  options = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
  };

  constructor(
    private http: HttpClient,
    private settings: ProjectSettingsService,
  ) {}

  getCatalogsVehicle(userGuid: string): Observable<CatalogsVehicleInterface> {
    const url = this.settings.generateEndpoint(EndpointConstants.ApiVehiclesCatalogs) + '?userGuid=' + userGuid;
    return this.http.get<CatalogsVehicleInterface>(url, this.options);
  }
}
